document.addEventListener("DOMContentLoaded", function () {
  const rows = document.querySelectorAll(".sponsors-logo-row");
  if (!rows.length) return;

  rows.forEach((row) => {
    const figures = row.querySelectorAll(".wp-block-image");
    if (!figures.length) return;

    // Group figures by row based on offsetTop
    const rowsMap = {};
    figures.forEach((figure) => {
      const top = figure.offsetTop;
      if (!rowsMap[top]) {
        rowsMap[top] = [];
      }
      rowsMap[top].push(figure);
    });

    // For each row, if exactly 2 images, mark them
    Object.values(rowsMap).forEach((group) => {
      if (group.length === 2) {
        group[0].classList.add("image-first");
        group[1].classList.add("image-last");
      }
    });
  });
});
